import React,{Component} from 'react';

//----Include Fragment Pages-----
import HeaderSection from '../websiteFolder/web_fragment/header';
import FooterPage from '../websiteFolder/web_fragment/footer';
//----End Include Fragment Pages-----

export default class privacyPolicyPagePanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : false,
            isLoggedin : false
        }
    }

    async componentDidMount(){
        this.setState({isLoaded:true});
    }

    render(){
        
        return (
          <div id="page-wrapper">
            <React.Fragment>
              <div id="main" className="mainSectionWebsite">
                <section className="header">
                  <div className="container">
                    <HeaderSection />
                    {/* <!-- Banner --> */}
                    <div className="row">
                      <div className="col-lg-12">
                        <h1 className="txt-style-6">Privacy Policy</h1>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sec4 sec4C sec4D">
                  <div className="container">
                    <div className="row">
                      <div className="col-xs-12">
                        <br/>
                        <p>
                          At Vyavsay, we value your trust and are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your personal and business information when you use our website, mobile application, and related services.
                        </p>
                        <br />
                        <h4>1. Information We Collect</h4>
                        <p>
                          When you use Vyavsay, we may collect the following types of information:
                        </p>
						<ul>
						<li><b>Personal Information:</b> Name, phone number, email address, and business name.</li>
						<li><b>Business Data:</b> Invoices, stock details, purchase/sales records, tax information (excluding sensitive financial details like bank passwords).</li>
						<li><b>Device Permissions:</b> We request access to your camera, contacts, storage, and location to help you easily attach bills, auto-fill party details, save reports, and personalize your app experience.</li>
						<li><b>Usage Data:</b> We collect non-personal data like device type, browser, pages visited, and session duration to improve our services.</li>
						</ul>
                        <br />
                        <h4>2. How We Use Your Information</h4>
                        <p>
                          We use the collected data to:
                        </p>
						<ul>
							<li>Provide core features like inventory tracking, invoicing, order management, and tax calculations.</li>
							<li>Improve the app experience by analyzing usage patterns.</li>
							<li>Send important service-related updates and occasional promotional offers (you can opt-out anytime).</li>
							<li>Personalize the platform based on your region and preferences.</li>
						</ul>
                        <br />
                        <h4>3. Your Data Belongs to You</h4>
                        <p>
                        You always own the content you create or store in your Vyavsay account. We do not sell or share your business data with third parties for marketing purposes.
						</p>
						<p>
						However, by using our service, you grant Vyavsay a limited license to access and use your content internally—for backups, system improvements, and customer support.
                        </p>
                        <br />
                        <h4>4. Keeping Your Data Secure</h4>
                        <p>We implement strong security protocols to protect your information, such as:</p>
                        <ul>
					    <li>End-to-end encryption</li>
						<li>Secure cloud storage with backups</li>
						<li>Regular software updates and threat monitoring</li>
						</ul>
                        <p>
                          While we strive to keep your data safe, no system is completely invulnerable, and Vyavsay cannot guarantee 100% protection against data breaches beyond our control.
                        </p>
                        <br />
                        <h4>5. Use of Cookies and Tracking Tools</h4>
                        <p>
                          To enhance your experience, we use cookies and similar tracking technologies. These tools help us:
                        </p>
						<ul>
						<li>Understand how users navigate the app or website</li>
						<li>Save your preferences and login details</li>
						<li>Deliver relevant content and promotional offers</li>
						</ul>
						<p>You can control or disable cookies in your browser settings, though some features of the site/app may not function as intended without them.</p>
                        <br />

                        <h4>6. Children’s Privacy</h4>
                        <p>Vyavsay is designed for business users and is not intended for children under 13 years of age. We do not knowingly collect personal information from minors. If we become aware that data from a child has been collected, it will be promptly deleted.</p>
                        <br/>

                        <h4>7. Ad Services and Third Parties</h4>
                        <p>Vyavsay may display limited promotional content. We do not sell your personal or business data to advertisers. In certain cases, we may work with third-party tools or service providers for analytics or app performance (e.g., Google Analytics), but they are bound by strict confidentiality agreements.</p>
                        <br/>

                        <h4>8. Data Storage and Transactions</h4>
                        <p>Your business data, including invoices, stock records, and reports, is:</p>
						<ul>
						<li>Stored securely on cloud-based servers</li>
						<li>Accessible only to you (and your authorized team)</li>
						<li>Synced when you're online and stored locally when you're offline</li>
						</ul>
						<p>All financial transactions or invoice records are encrypted and stored for your privacy.</p>
                        <br/>

                        <h4>9. Communications and Consent</h4>
                        <p>By signing up, you agree to receive transactional messages and occasional promotional content via SMS, email, or app notifications. You can manage your communication preferences in the app settings.</p>
                        <br/>

                        <h4>10. Changes to This Policy</h4>
                        <p>Vyavsay may update this Privacy Policy from time to time. If significant changes are made, we’ll notify you through email or in-app alerts.</p>
                        <br/>

                        <h4>Contact Us</h4>
                        <p>If you have questions or concerns about our Privacy Policy or how your data is used, please write to us at:</p>
						<p><b>contact@vyavsay.in</b></p>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Footer Code Here */}
                <FooterPage />
              </div>
            </React.Fragment>
          </div>
        );
    }
}